import * as Tour from './Tour';
import * as WebGL from './WebGL';
import * as UI from './UI';

export default {
    Tour,
    WebGL,
    UI
}



// WEBPACK FOOTER //
// ./src/constants/index.js